import React from "react";
import ArticleCard from "../components/ArticleCard";
import FeatureCard from "../components/FeatureCard";
import TeamCard from "../components/TeamCard";
import "./LandingPage.css";
import NavBar from "../components/NavBar.js";

import pic1 from "../assets/Website graphics 3.png";
import pic2 from "../assets/Unauthenticated News1.png";
import pic3 from "../assets/Broken user experience1.png";
import pic4 from "../assets/No fair pay1.png";
import pic5 from "../assets/Centralized platforms1.png";
import pic6 from "../assets/User data1.png";
import pic7 from "../assets/1.png";
import pic8 from "../assets/3.png";
import pic9 from "../assets/2.png";
import pic10 from "../assets/4.png";

import team1 from "../assets/Team New/Kunal Goyal.png";
import team2 from "../assets/Team New/Reshmi Mitra.png";
import team3 from "../assets/Team New/Shreejata Neogi.png";
import team4 from "../assets/Team New/Kundan Mishra.png";
import team5 from "../assets/Team New/Keshava Varmaa S.png";
import team6 from "../assets/Team New/Rahul Manoj.png";
import team7 from "../assets/Team New/Joel Dsouza.png";
import team8 from "../assets/Team New/Wasim Bari.png";
import team9 from "../assets/Team New/Soumitra Sen.png";

const LandingPage = () => {
  const teams = [
    {
      name: "Joel DSouza",
      position: "Operations and Growth Lead",
      img: team7,
      linkedin: "https://www.linkedin.com/in/joel-d-souza-860a2916b/",
    },
    {
      name: "Wasim Bari",
      position: "Blockchain Developer",
      img: team8,
      linkedin: "https://www.linkedin.com/in/wasim-bari-it/",
    },
    {
      name: "Kunal Goyal",
      position: "Blockchain Developer",
      img: team1,
      linkedin: "https://www.linkedin.com/in/kunalgoyal9/",
    },
    {
      name: "Reshmi Mitra",
      position: "PR Consultant",
      img: team2,
      linkedin: "https://www.linkedin.com/in/reshmi-mitra/",
    },
    {
      name: "Shreejata Neogi",
      position: "Graphic & Video Lead",
      img: team3,
      linkedin: "https://www.linkedin.com/in/shreejata-neogi-0b37b1165/",
    },
    {
      name: "Kundan Mishra",
      position: "Blockchain Developer",
      img: team4,
      linkedin: "https://www.linkedin.com/in/kundan-mishra-83a7991bb/",
    },
    {
      name: "Keshavavarmaa",
      position: "Full Stack Developer",
      img: team5,
      linkedin: "https://www.linkedin.com/in/keshava-varmaa-896a441b0/",
    },
    {
      name: "Rahul Manoj",
      position: "Content Lead",
      img: team9,
      linkedin:
        "https://www.linkedin.com/in/soumitra-sen-blockchain-content-writer-44a44b166/",
    },
  ];

  const news = [
    {
      id: 1,
      title:
        "Wilson Bright on building the BlockSurvey book of digital privacy and ownership of ideas, identity and data",
      description:
        "One of YourStory’s Tech50 2021 startups, here’s how BlockSurvey is working as an alternative to free platforms in the underserved space of ....",
      img: "https://images.yourstory.com/cs/2/0e302530227f11ec9e19b7c38d296967/BlockSurvey2Wilson-1638513335483.png?fm=auto&ar=2:1&mode=crop&crop=faces&w=720",
    },
    {
      id: 2,
      title:
        "Crypto.com to Create First-of-Its-Kind NFT Collection Generated by the Speed and Sound of the ...",
      description:
        "Crypto.com, the world’s fastest growing cryptocurrency platform, will create a collection of NFTs generated in real-time by the speed, sound and data of the Formula 1 ....",
      img: "https://content-hub-static.crypto.com/static/1d2cae47358a2dc22b8669d7fd92f486/d7166/CDC-Kinetica-Title_1200x728.png",
    },
    {
      id: 3,
      title:
        "Meet the engineers building a simple mobile wallet for using blockchain-based apps",
      description:
        "Abhimanyu Shekhawat and Akshit Ostwal started developing Orange Wallet in December 2020 to provide a simple, mobile experience for users to access blockchain-based Decentralised ....",
      img: "https://images.yourstory.com/cs/2/98e25df018b511e988ceff9061f4e5e7/OrangeWallet800x400-1630423976792.png?fm=auto&ar=2:1&mode=crop&crop=faces&w=720",
    },
    {
      id: 4,
      title:
        "UniFarm launches 3 back-to-back IDOs, listing on 3 top centralized exchanges & much more",
      description:
        "Leading group farming staking protocol- ‘UniFarm’ which announced its IDO Launchpad- ‘UNIFARM Launch’ earlier last month is all set to announce 3 new back-to-back IDOs for its rapidly ....",
      img: "https://www.dqindia.com/wp-content/uploads/2021/09/Blockchain-in-healthcare1.jpg",
    },
  ];

  const navRef = React.createRef();

  const handleNav = (direction) => {
    if (direction === "left") {
      return navRef ? (navRef.current.scrollLeft -= 900) : null;
    } else {
      return navRef ? (navRef.current.scrollLeft += 900) : null;
    }
  };

  return (
    <>
      <NavBar />
      <div className="pt-0 pb-8 main_div">
        <div id="landing1" className="py-4">
          <div className="intro_div md:px-16 px-0 md:text-left text-center py-20">
            <div className="flex md:flex-row flex-col">
              <div className="mt-auto py-8 md:pl-4 md:pr-24 pr-0 md:mx-0 mx-8">
                <h1 className="md:text-5xl text-4xl font-bold mb-5 md:text-left text-center text-white">
                  Enabling ad-free, verified, & community first media platform
                </h1>
                <p className="md:text-left text-xl text-center mb-5 text-white">
                  A decentralized community-driven platform helping users combat
                  misinformation with the power of Web3
                </p>
                <button class="border-2 font-bold bg-white text-orange-500  hover:underline px-4 py-2 transition-all">
                  Explore Now
                </button>
              </div>
              <div className="md:px-4 px-0 my-auto md:mx-0 mx-4 z-10">
                <img
                  width="741"
                  height="562"
                  src={pic1}
                  class="attachment-full size-full"
                  alt="img"
                  loading="lazy"
                  sizes="(max-width: 741px) 100vw, 741px"
                />
              </div>
            </div>
          </div>
        </div>

        <div id="landing2" className="">
          <div className="features_div text-center md:px-10 px-8 md:pt-0 pt-10">
            <h1 className="text-3xl font-bold md:mb-16 mb-8">Why Newschain?</h1>
            <div className="feature_cards_row grid md:grid-cols-5 md:grid-rows-1 grid-cols-1 grid-rows-2 md:gap-5 gap-4">
              <FeatureCard
                title={"Unauthenticated News"}
                description={
                  "The online news space has become chaotic and biased"
                }
                img={pic2}
                classes="feature_img"
              />
              <FeatureCard
                title={"Broken user experience"}
                description={
                  "More Ads than real news along with a cluttered UI"
                }
                img={pic3}
                classes="feature_img"
              />
              <FeatureCard
                title={"No fair pay to the content creators"}
                description={
                  "No judicious reward system for the content creators"
                }
                img={pic4}
                classes="feature_img"
              />
              <FeatureCard
                title={"Centralized platforms"}
                description={
                  "Centralization steals away the right to free speech"
                }
                img={pic5}
                classes="feature_img"
              />
              <FeatureCard
                title={"Breach in user data"}
                description={"User data is compromised in centralised platform"}
                img={pic6}
                classes="feature_img"
              />
            </div>
          </div>

          <div className="special_div lg:px-16 px-8 mt-24" id="solutions">
            <h1 className="text-3xl text-center font-bold mb-12">
              What makes Newschain different?
            </h1>
            <div className="special_flex_div flex md:flex-row flex-col mb-12 h-full w-full bg-orange-100 rounded-xl md:py-0 py-4">
              <div className="mx-8 my-auto md:w-2/3">
                <h1 className="text-3xl font-bold md:mb-8 mb-4 md:text-left text-center">
                  Decentralised
                </h1>
                <p className="text-xl md:text-left text-center">
                  We are building the platform to be completely decentralised,
                  wherein members of the community will both contribute to, and
                  verify all the news published on the platform. For both these
                  activities, they will receive remuneration in the form of
                  (coin) tokens.
                </p>
              </div>
              <div className="md:w-1/3 my-4 md:mr-1 mr-0">
                <img
                  src={pic7}
                  class="attachment-full size-full md:h-72 h-64 md:mt-0 mt-6 mx-auto px-2 md:px-0"
                  alt="img"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="special_flex_div flex md:flex-row-reverse flex-col mb-12 h-full w-full bg-orange-100 rounded-xl md:py-0 py-4">
              <div className="mx-8 my-auto md:w-2/3">
                <h1 className="text-3xl font-bold md:mb-8 mb-4 md:text-right text-center">
                  Ad-free
                </h1>
                <p className="text-xl md:text-right text-center">
                  Our main intent at Newschain is to cut the noise in the media
                  industry and publish only relevant, legit news from verified
                  sources. For this purpose, we will keep our platform 100%
                  ad-free and no paid content will be shared by us, ever.
                </p>
              </div>
              <div className="md:w-1/3 my-4">
                <img
                  src={pic8}
                  class="attachment-full size-full md:h-64 md:mt-0 mt-12 md:mx-auto mx-auto px-2 md:px-0"
                  alt="img"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="special_flex_div flex md:flex-row flex-col mb-12 h-full w-full bg-orange-100 rounded-xl md:py-0 py-4">
              <div className="mx-8 my-auto md:w-2/3">
                <h1 className="text-3xl font-bold md:mb-8 mb-4 md:text-left text-center">
                  Fair Pay to contributors
                </h1>
                <p className="text-xl md:text-left text-center">
                  As mentioned earlier, we will ensure fair, pre-agreed, regular
                  (coin) token payments to content creators, contributors, and
                  journalists on the Newschain platform.
                </p>
              </div>
              <div className="md:w-1/3 my-4">
                <img
                  src={pic9}
                  class="attachment-full size-full md:h-72 h-64 md:mt-0 mt-12 mx-auto px-2 md:px-0"
                  alt="img"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="special_flex_div flex md:flex-row-reverse flex-col mb-12 h-full w-full bg-orange-100 rounded-xl md:py-0 py-4">
              <div className="mx-8 my-auto md:w-2/3">
                <h1 className="text-3xl font-bold md:mb-8 mb-4 md:text-right text-center">
                  Verified Content
                </h1>
                <p className="text-xl md:text-right text-center">
                  Similar to contributors, members of the community can also
                  mine tokens by verifying content on the platform. This will
                  ensure only legit content is published on the platform.
                </p>
              </div>
              <div className="md:w-1/3 my-4">
                <img
                  src={pic10}
                  class="attachment-full size-full md:h-72 h-64 md:mt-0 mt-12 mx-auto px-2 md:px-0"
                  alt="img"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="news_bits md:px-16 px-8 md:mt-16 mt-8">
            <div className="flex md:flex-row flex-col">
              <h1 className="line_heading text-3xl font-bold">
                From The NewsChain
              </h1>
            </div>
            <div className="grid md:grid-cols-4 grid-cols-1 gap-8 mt-8 ">
              {news.map((article) => {
                return (
                  <ArticleCard
                    title={article.title}
                    description={article.description}
                    img={article.img}
                    id={article.id}
                  />
                );
              })}
            </div>
          </div>

          <div className="team_div mt-16" id="team_div">
            <h1 className="text-3xl font-bold text-center px-8 ">
              The Team behind NewsChain
            </h1>
            <div
              className="absolute p-2 rounded-full z-2 left-4 my-40 visibility_btn cursor-pointer"
              onClick={() => handleNav("left")}
            >
              <svg
                class="w-8 h-8"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
            <div
              className="absolute p-2 rounded-full right-4 z-2 my-40 visibility_btn cursor-pointer"
              onClick={() => handleNav("right")}
            >
              <svg
                class="w-8 h-8"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
            <div
              class="flex flex-row grid_container mt-16 overflow-x-hidden md:mx-16 mx-4"
              ref={navRef}
            >
              {teams.map((team) => {
                return (
                  <TeamCard
                    name={team.name}
                    position={team.position}
                    img={team.img}
                    linkedin={team.linkedin}
                  />
                );
              })}
            </div>
          </div>

          {/* <div className="subscribe_comp md:py-2 px-8 my-12">
          <h1 className="text-3xl font-bold text-center">
            {" "}
            Join Our Community
          </h1>
          <div className="rounded-3xl shadow-lg w-full p-8 mt-12 bg-white gradient_card">
            <p className="text-xl font-bold mb-5 text-white">
              Sign Up for the NewsLetter
            </p>
            <div className="flex md:flex-row flex-col">
              <input
                type="text"
                placeholder="Enter your Email Address"
                className="p-4 rounded-3xl flex-1"
              />
              <button className="md:ml-2 ml-0 md:mt-0 mt-5 text-white flex-0 bg-orange-500 hover:bg-orange-700 rounded-3xl hover:shadow-lg transition-all duration-500 p-4">
                Subscribe
              </button>
            </div>
            <p className="font-medium text-white mt-4">
              *Your Email Address is fully secure. We dont share it with anyone!
            </p>
            <h2 className="text-xl font-semibold text-white my-5">Benefits</h2>
            <p className="font-medium text-white">
              Your Email Address is fully secure. We dont share it with anyone!
            </p>
            <p className="font-medium text-white">
              Your Email Address is fully secure. We dont share it with anyone!
            </p>
            <p className="font-medium text-white">
              Your Email Address is fully secure. We dont share it with anyone!
            </p>
          </div>
        </div> */}
        </div>

        <div className="footer_m flex flex-row gap-2" id="footer_m">
          <a href="/">
            <span className="text-3xl mr-1 pt-2 font-bold"> Newschain</span>
          </a>

          <div className="flex flex-row justify-around text-center w-full">
            <div className="mx-2" style={{ placeItems: "center" }}>
              <a href=" " className="button11 current">
                Privacy Policy
              </a>
            </div>
            <div className="mx-2" style={{ placeItems: "center" }}>
              <a href=" " className="button11 current">
                Terms and Conditions
              </a>
            </div>
            <div className="mx-2" style={{ placeItems: "center" }}>
              <a
                href="mailto:hello@thenewschain.co"
                className="button11 current"
              >
                Contact Us
              </a>
            </div>
          </div>

          <div className="landing__foot__icons flex flex-row ">
            <a
              href="https://twitter.com/The_Newschain"
              target="_blank"
              rel="noreferrer"
              className="mx-1"
            >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGnSURBVHgBtVbdbcIwED6bDMAGDRsQfh54ajpBuwGwARuQTEI6QdsJSl9BkHSDdILmHUH6HXKkNroEp5BPMpZP+Pt857tzFBlst1u/0+ks8zzvY9mlf0IptT6dTtFoNHo+r/lnt9sFmJZ0W4TD4TBQIJ9hsaIWAE8eNFyaUkvgkGvE3KeWwPepqV10RQGELa3bhZOt8R8fl6i01j2YIozMzH+5cMm5IOCb0AUCfwriXtkYx3EXl8qZOKNfaV4VIiYJMc/L3kA4kDZ4nscefFKphkQBkMx4hkgEAY+FOCyYM2RGJu2BBy4J6S6GiMkOh8N8MpmkZInNZtOHeFy2V3kQNiE/E2ntinbJyAVCDYFQPloLcAYhdKv9fn9H9gK+tYBBNhgMvsgC3CxxKLepwMJ02VqY7KkM6aVWsYTICxdRFTlO/l5H4Ai2FOMVG1NkRoIwfUgbIbwwlVv7OIl1UIiA4M1xnISrlL1AbbgQvcd4su3CLPBNVzyRl8APTkItgTuCPh6PIbWHSI/H4zXJbflaBPxloYoVP/5waVpVkZbIwJEgCYIi+34ATGDGNz/K05IAAAAASUVORK5CYII="
                alt="twitter"
                id="icons"
              ></img>
            </a>
            <a
              href="https://www.instagram.com/thenewschain/"
              target="_blank"
              rel="noreferrer"
              className="mx-1"
            >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFXSURBVHgB7VXdUYQwEE4CBWgHlCC/M7xhB1rB2cnlKtAO7uxAKxCf+ZES7ECemQH89gQHudwxBm588ZuBzH6EJN/uZpezDkmSRIZhrNu2vYJ5wTTBOY+bptl5nve4t+mVZZnEsGbLYuO6ruRY/A7Glp0BUHItIGml+PYAPsIo2QyQy0lBOyQRgwL+s3s7z/O3Li46KMWYwcnHAdYOOP1rKkgLqrY49TO5CaPFZuDARUtDqEikF++fI1yJRwohLsmu65pi9qRaS+WiSVRVZYdh+N7bQRAUGG6REC9wacSmFExhuPgQULIZc1oK0jS9QQLQ5SxxYtmXBdM0C1yuH3O1FMD39+wrfS1sJHvetu3yYC7TwCh1rVNztTb4Df43+PsNqBZ9sHkV8ySo4RTsTEA6x0J1vRfETvi+H7OZrfEI9iXkuxxT84ekVdeLdUG1qUApkY7jvBLxCYWygiQ7y9ArAAAAAElFTkSuQmCC"
                alt="linkedin"
                id="icons"
              ></img>
            </a>
            <a
              href="https://www.linkedin.com/company/thenewschain/"
              target="_blank"
              rel="noreferrer"
              className="mx-1"
            >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEESURBVHgB7ZXNEYJADIWzCwVYAiXI3x0r0RLswLUStRM8M4Ad2AIF8OOL4zpclIhw4zsACy/JvOwyUfQiy7LEcZxD13VrLFc0EqVU2rbtOYqiy3PNlzzPDW4HmpZjGIZGIfkOixPNAJxsNCxtaSa45S56ngj1FbQGQRff9yv7Eh3oPgXwfrokBOK93bgfWGmpckTyJ2IHfYqiuMORJ9GKHfSRJmfUt01icJbVt+9D8aMcWMqy9IY0fxWo69ob0gy2yNJvlTSG+cvBUmAp8C5Q0Yy4GDg3yUz45exbkDfVTdMcaT7OOo7jFA+GpsfwDOn//jtY2qJlCY2Hx+pNa22CILjyiwczlG3mydx+agAAAABJRU5ErkJggg=="
                alt="facebook"
                is="icons"
              ></img>
            </a>
          </div>
        </div>

        <div
          className="footer_copyright mx-auto text-center"
          style={{ placeItems: "center" }}
        >
          <a href="#0" className="button11 current">
            <i className="mdi mdi-copyright"></i>2022 Newschain. All Rights
            Reserved.
          </a>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
